<template>
    <div>
        
        <!-- Page header -->
        <div class="page-header page-header-light shadow">
            <div class="page-header-content d-lg-flex">
                <div class="d-flex">
                    <h6 class="page-title mb-0">
                        <span class="text-muted">Dashboard {{ $root.VERSIONE }}</span>
                    </h6>
                    <a href="#page_header" class="btn btn-light align-self-center collapsed d-lg-none border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
                        <i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
                    </a>
                </div>
                <div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
                    <div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
                        <span class="btn btn-light">Oggi: <span class="ms-1">{{ filters.formatDate(today) }}</span></span>
                        <a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 me-2 position-10" style="text-align: left;">
                        
                        </a>

                        <div class="vr flex-shrink-0 my-2 mx-3"></div>

                        <div class="d-inline-flex mb-xs-1 mt-sm-0">
                            <a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="filters.openRoute('/Statistiche')" title="Statistiche" data-bs-toggle="tooltip" data-bs-placement="left">
                                <i class="ph-lightning"></i>
                            </a>
                            <a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(57)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
                                <i class="icon-question7" style="color: orange;"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /page header -->

        <!-- Content area -->
        <div class="content content-1">

            <div class="row">
                <div class="col-lg-9">

                    <div class="row">
                        <div class="col-12 col-sm-4 col-md-5 col-lg-3 col-xl-4 col-xxl-4">

                            <div class="card text-white shadow">
                                <div class="card-header card mb-0 pt-1 pb-1" v-bind:class="getClasseBarra()">
                                    <h1 class="card-title mb-0">
                                        <Translate :path="'dizionario.base.BENVENUTO'"></Translate> {{utente.USERNAME}}
                                    </h1>
                                </div>
                                <div class="card-body pt-1" style="height: 12.71rem;">
                                    <p class="text-dark">
                                        Non ci sono nuovi aggiornamenti.<br />
                                        <Translate :path="'dizionario.base.SYS_PRONTO'"></Translate>
                                    </p>
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-lg-8">
                            <div class="row">
                                <div class="col-6 col-lg-4">

                                    <div class="card card-body">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="flex-fill">
                                                <h6 class="mb-0">Server</h6>
                                                <span class="text-muted">Debian 12</span>
                                            </div>
                                            <i class="ph-activity ph-2x text-danger opacity-75 ms-3"></i>
                                        </div>
                                        <div class="progress mb-2" style="height: 0.125rem;">
                                            <div class="progress-bar bg-danger" style="width: 67%"></div>
                                        </div>
                                        <div>
                                            <span class="float-end">67%</span> Re-indexing
                                        </div>
                                    </div>

                                </div>
                                <div class="col-6 col-lg-4">

                                    <div class="card card-body">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="flex-fill">
                                                <h6 class="mb-0">Mysql</h6>
                                                <span class="text-muted">MariaDB 12.5</span>
                                            </div>
                                            <i class="ph-database ph-2x text-indigo opacity-75 ms-3"></i>
                                        </div>
                                        <div class="progress mb-2" style="height: 0.125rem;">
                                            <div class="progress-bar bg-indigo" style="width: 80%"></div>
                                        </div>
                                        <div>
                                            <span class="float-end">67%</span> Re-indexing
                                        </div>
                                    </div>

                                </div>
                                <div class="col-6 col-lg-4">

                                    <div class="card card-body">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="flex-fill">
                                                <h6 class="mb-0">Php</h6>
                                                <span class="text-muted"><Translate :path="'dizionario.base.VERSION'"></Translate> 8.3.0</span>
                                            </div>

                                            <i class="ph-code ph-2x text-indigo opacity-75 ms-3"></i>
                                        </div>
                                        <div class="progress mb-2" style="height: 0.125rem;">
                                            <div class="progress-bar bg-indigo" style="width: 67%"></div>
                                        </div>
                                        <div>
                                            <span class="float-end">67%</span> Re-indexing
                                        </div>
                                    </div>

                                </div>
                                <div class="col-6 col-lg-4">

                                    <div class="card card-body">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="flex-fill">
                                                <h6 class="mb-0">Cms-Travel</h6>
                                                <span class="text-muted"><Translate :path="'dizionario.base.VERSION'"></Translate> 2.0</span>
                                            </div>
                                            <i class="ph-infinity ph-2x text-indigo opacity-75 ms-3"></i>
                                        </div>
                                        <div class="progress mb-2" style="height: 0.125rem;">
                                            <div class="progress-bar bg-indigo" style="width: 67%"></div>
                                        </div>
                                        <div>
                                            <span class="float-end">67%</span> Re-indexing
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>  


                    <div class="row">
                        <div class="col-lg-12">

                            <div class="card mb-3" style="height: 100%;">
                                <div class="card-header d-sm-flex align-items-sm-center py-sm-0">
                                    <h5 class="py-sm-2 my-sm-1"><span class="me-2"><Translate :path="'dizionario.base.MANAGEMENT'"></Translate> Tickets:</span></h5>
                                    <div class="mt-2 mt-sm-0 ms-sm-auto">
                                        <select class="form-select" id="select_date">
                                            <option value="val1"><span v-if="$root.enteCorrente != undefined">{{ $root.enteCorrente.LABEL }}</span></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <ul class="nav nav-tabs nav-tabs-underline nav-justified mb-0" role="tablist">
                                        <li class="nav-item" role="presentation"><a href="#mind-1" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">NUOVI</a></li>
                                        <li class="nav-item" role="presentation"><a href="#mind-2" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1">IN LAVORAZIONE</a></li>
                                        <li class="nav-item" role="presentation"><a href="#mind-3" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1">EVASI</a></li>
                                        <li class="nav-item" role="presentation"><a href="#mind-4" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1">ANNULLATI</a></li>
                                    </ul>
                                    <div class="tab-content card-body">

                                        <div class="tab-pane fade active show" id="mind-1" role="tabpanel"> 
                                            <div class="bg-light mt-1">
                                                <p class="fs-lg fw-bold p-1">
                                                    <i class="icon-calendar me-2"></i>Elenco Ordini di Oggi
                                                    <span class="ms-1">(93)</span>
                                                </p> 
                                            </div>                                        
                                            <div class="table-responsive">
                                                <div class="box-memo">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 50px">Due</th>
                                                                <th style="width: 300px;">User</th>
                                                                <th>Description</th>
                                                                <th class="text-center" style="width: 20px;">
                                                                    <i class="ph-dots-three"></i>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr>
                                                                <td class="text-center">
                                                                    <h6 class="mb-0">12</h6>
                                                                    <div class="fs-sm text-muted lh-1">hours</div>
                                                                </td>
                                                                <td>
                                                                    <div class="d-flex align-items-center">
                                                                        <a href="#" class="d-inline-flex align-items-center justify-content-center bg-teal text-white lh-1 rounded-pill w-40px h-40px me-3">
                                                                            <span class="letter-icon">AD</span>
                                                                        </a>
                                                                        <div>
                                                                            <a href="#" class="text-body fw-semibold letter-icon-title">Annabelle Doney</a>
                                                                            <div class="d-flex align-items-center text-muted fs-sm">
                                                                                <span class="bg-danger rounded-pill p-1 me-2"></span>
                                                                                Blocker
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a href="#" class="text-body">
                                                                        <div class="fw-semibold">[#1183] Workaround for OS X selects printing bug</div>
                                                                        <span class="text-muted">Chrome fixed the bug several versions ago, thus rendering this...</span>
                                                                    </a>
                                                                </td>
                                                                <td class="text-center">
                                                                    <div class="dropdown">
                                                                        <a href="#" class="text-body" data-bs-toggle="dropdown">
                                                                            <i class="ph-list"></i>
                                                                        </a>
                                                                        <div class="dropdown-menu dropdown-menu-end">
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-arrow-bend-up-left me-2"></i>
                                                                                Quick reply
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-clock-counter-clockwise me-2"></i>
                                                                                Full history
                                                                            </a>
                                                                            <div class="dropdown-divider"></div>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-checks text-success me-2"></i>
                                                                                Resolve issue
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-x text-danger me-2"></i>
                                                                                Close issue
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>   
                                        </div>

                                        <div class="tab-pane fade" id="mind-2" role="tabpanel">  
                                            <div class="bg-light mt-1">
                                                <p class="fs-lg fw-bold p-1">
                                                    <i class="icon-calendar me-2"></i>Elenco Ordini di Oggi
                                                    <span class="ms-1">(93)</span>
                                                </p> 
                                            </div>                                        
                                            <div class="table-responsive">
                                                <div class="box-memo">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 50px">Due</th>
                                                                <th style="width: 300px;">User</th>
                                                                <th>Description</th>
                                                                <th class="text-center" style="width: 20px;">
                                                                    <i class="ph-dots-three"></i>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr>
                                                                <td class="text-center">
                                                                    <h6 class="mb-0">12</h6>
                                                                    <div class="fs-sm text-muted lh-1">hours</div>
                                                                </td>
                                                                <td>
                                                                    <div class="d-flex align-items-center">
                                                                        <a href="#" class="d-inline-flex align-items-center justify-content-center bg-teal text-white lh-1 rounded-pill w-40px h-40px me-3">
                                                                            <span class="letter-icon">AD</span>
                                                                        </a>
                                                                        <div>
                                                                            <a href="#" class="text-body fw-semibold letter-icon-title">Annabelle Doney</a>
                                                                            <div class="d-flex align-items-center text-muted fs-sm">
                                                                                <span class="bg-danger rounded-pill p-1 me-2"></span>
                                                                                Blocker
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a href="#" class="text-body">
                                                                        <div class="fw-semibold">[#1183] Workaround for OS X selects printing bug</div>
                                                                        <span class="text-muted">Chrome fixed the bug several versions ago, thus rendering this...</span>
                                                                    </a>
                                                                </td>
                                                                <td class="text-center">
                                                                    <div class="dropdown">
                                                                        <a href="#" class="text-body" data-bs-toggle="dropdown">
                                                                            <i class="ph-list"></i>
                                                                        </a>
                                                                        <div class="dropdown-menu dropdown-menu-end">
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-arrow-bend-up-left me-2"></i>
                                                                                Quick reply
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-clock-counter-clockwise me-2"></i>
                                                                                Full history
                                                                            </a>
                                                                            <div class="dropdown-divider"></div>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-checks text-success me-2"></i>
                                                                                Resolve issue
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-x text-danger me-2"></i>
                                                                                Close issue
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                            
                                        </div>

                                        <div class="tab-pane fade" id="mind-3" role="tabpanel">
                                            <div class="bg-light mt-1">
                                                <p class="fs-lg fw-bold p-1">
                                                    <i class="icon-calendar me-2"></i>Elenco Ordini di Oggi
                                                    <span class="ms-1">(93)</span>
                                                </p> 
                                            </div>                                        
                                            <div class="table-responsive">
                                                <div class="box-memo">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 50px">Due</th>
                                                                <th style="width: 300px;">User</th>
                                                                <th>Description</th>
                                                                <th class="text-center" style="width: 20px;">
                                                                    <i class="ph-dots-three"></i>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr>
                                                                <td class="text-center">
                                                                    <h6 class="mb-0">12</h6>
                                                                    <div class="fs-sm text-muted lh-1">hours</div>
                                                                </td>
                                                                <td>
                                                                    <div class="d-flex align-items-center">
                                                                        <a href="#" class="d-inline-flex align-items-center justify-content-center bg-teal text-white lh-1 rounded-pill w-40px h-40px me-3">
                                                                            <span class="letter-icon">AD</span>
                                                                        </a>
                                                                        <div>
                                                                            <a href="#" class="text-body fw-semibold letter-icon-title">Annabelle Doney</a>
                                                                            <div class="d-flex align-items-center text-muted fs-sm">
                                                                                <span class="bg-danger rounded-pill p-1 me-2"></span>
                                                                                Blocker
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a href="#" class="text-body">
                                                                        <div class="fw-semibold">[#1183] Workaround for OS X selects printing bug</div>
                                                                        <span class="text-muted">Chrome fixed the bug several versions ago, thus rendering this...</span>
                                                                    </a>
                                                                </td>
                                                                <td class="text-center">
                                                                    <div class="dropdown">
                                                                        <a href="#" class="text-body" data-bs-toggle="dropdown">
                                                                            <i class="ph-list"></i>
                                                                        </a>
                                                                        <div class="dropdown-menu dropdown-menu-end">
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-arrow-bend-up-left me-2"></i>
                                                                                Quick reply
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-clock-counter-clockwise me-2"></i>
                                                                                Full history
                                                                            </a>
                                                                            <div class="dropdown-divider"></div>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-checks text-success me-2"></i>
                                                                                Resolve issue
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-x text-danger me-2"></i>
                                                                                Close issue
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>   
                                        </div>

                                        <div class="tab-pane fade" id="mind-4" role="tabpanel">
                                            <div class="bg-light mt-1">
                                                <p class="fs-lg fw-bold p-1">
                                                    <i class="icon-calendar me-2"></i>Elenco Ordini di Oggi
                                                    <span class="ms-1">(93)</span>
                                                </p> 
                                            </div>                                        
                                            <div class="table-responsive">
                                                <div class="box-memo">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 50px">Due</th>
                                                                <th style="width: 300px;">User</th>
                                                                <th>Description</th>
                                                                <th class="text-center" style="width: 20px;">
                                                                    <i class="ph-dots-three"></i>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr>
                                                                <td class="text-center">
                                                                    <h6 class="mb-0">12</h6>
                                                                    <div class="fs-sm text-muted lh-1">hours</div>
                                                                </td>
                                                                <td>
                                                                    <div class="d-flex align-items-center">
                                                                        <a href="#" class="d-inline-flex align-items-center justify-content-center bg-teal text-white lh-1 rounded-pill w-40px h-40px me-3">
                                                                            <span class="letter-icon">AD</span>
                                                                        </a>
                                                                        <div>
                                                                            <a href="#" class="text-body fw-semibold letter-icon-title">Annabelle Doney</a>
                                                                            <div class="d-flex align-items-center text-muted fs-sm">
                                                                                <span class="bg-danger rounded-pill p-1 me-2"></span>
                                                                                Blocker
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a href="#" class="text-body">
                                                                        <div class="fw-semibold">[#1183] Workaround for OS X selects printing bug</div>
                                                                        <span class="text-muted">Chrome fixed the bug several versions ago, thus rendering this...</span>
                                                                    </a>
                                                                </td>
                                                                <td class="text-center">
                                                                    <div class="dropdown">
                                                                        <a href="#" class="text-body" data-bs-toggle="dropdown">
                                                                            <i class="ph-list"></i>
                                                                        </a>
                                                                        <div class="dropdown-menu dropdown-menu-end">
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-arrow-bend-up-left me-2"></i>
                                                                                Quick reply
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-clock-counter-clockwise me-2"></i>
                                                                                Full history
                                                                            </a>
                                                                            <div class="dropdown-divider"></div>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-checks text-success me-2"></i>
                                                                                Resolve issue
                                                                            </a>
                                                                            <a href="#" class="dropdown-item">
                                                                                <i class="ph-x text-danger me-2"></i>
                                                                                Close issue
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>   
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>


                </div>
                <div class="col-sm-6 col-xl-3">
                    
                    <div class="card" style="height: 100%;">
                        <ul class="nav nav-tabs nav-tabs-underline nav-justified mb-0" role="tablist">
                            <li class="nav-item" role="presentation"><a href="#tab-desc_1" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">To Do</a></li>
                            <li class="nav-item" role="presentation"><a href="#tab-desc_2" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">Chat</a></li>
                            <li class="nav-item" role="presentation"><a href="#tab-desc_3" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab"><Translate :path="'dizionario.base.NOTIFICATIONS'"></Translate></a></li>
                        </ul>

                        <div class="tab-content card-body">
                            <div class="tab-pane fade show active" id="tab-desc_1" role="tabpanel">
                                <div style="height: 33rem;">

                                    <Task :isDashboard = 1></Task>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="tab-desc_2" role="tabpanel">

                                <div style="height: 33rem;">
                                    <div class="dropdown-menu-scrollable pb-0" v-for="msg in arrayMessaggiNonLetti.messaggi_non_letti" v-bind:value="msg.ID_MESSAGE" v-bind:key="msg.ID_MESSAGE">
                                        <a href="#" class="dropdown-item align-items-start text-wrap py-2">
                                            <div class="status-indicator-container me-3">
                                                <img v-if="msg.ID_PERSONA_FISICA > 0 && msg.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',msg.URL_AVATAR)" class="w-40px h-40px rounded-pill" alt="" />
                                                <img v-if="msg.URL_AVATAR == 'placeholder.jpg'" src="../../assets/images/face11.jpg" class="w-40px h-40px rounded-pill" alt="">
                                                <span class="status-indicator " v-bind:class="{'bg-danger':msg.STATO_ACCESSO == 0,'bg-success':msg.STATO_ACCESSO == 1,'bg-warning':msg.STATO_ACCESSO == 2}"></span>
                                            </div>
                                            <div class="flex-1">
                                                <span class="fw-semibold">{{ msg.USERNAME }}</span>
                                                <span class="text-muted float-end fs-sm">{{ msg.DATA_INVIO }}</span>
                                                <div class="text-muted">{{ msg.TEXT }}</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                            </div>

                            <div class="tab-pane fade" id="tab-desc_3" role="tabpanel">
                                <div style="height: 33rem;">

                                    

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>        
</template>



<script>
//import DatePicker from '@/components/utils/DatePicker.vue'
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Task from '../../components/Task.vue';


export default {
    name:'Dashboard1',	

    components:{
        //ckeditor: ClassicEditor.component,
        Task,
    },					

    props: ['todo'],		

    data:function(){
        return{
            filters:global.filters,
            t:global.t,
            utente:{},
            today: new Date().toISOString().split('T')[0],
            startInterval:{},
            arrayRisultatiRicerca:new Array(),
            arrayMessaggiNonLetti : new Array(),
            prova:0,
            isDashboard: 0,
        }
    },

    methods:{
        goToRoute: function(route){
            global.router.push(route);
        }, 

        varianti : function(){
            this.$root.appoggio.prodotto = {ID_PRODOTTO:1};
            this.$root.changeRoute('varianti');
        },

        ricercaResultHandler : function(data){
            this.arrayRisultatiRicerca = new Array();
            this.arrayRisultatiRicerca = data.RISULTATI;
        },

        testAlert : function(){   
            utils.alert.success("ciaone");
            utils.alert.warning("ciaone");
            utils.alert.info("ciaone");
            utils.alert.primary("ciaone");
            utils.alert.danger("ciaone");
        },

        openRoute : function(route){
            global.router.push(route);
        },

		getClasseBarra : function(){
            var colore = this.filters.getOpzioneUtente("TOPBAR");
            switch (colore){
                case 234:
                    return "bg-danger";
            }
            return "bg-info";
        },

        getMessaggiNonLetti() {
			console.log('Recupero dei messaggi...');
			utils.ajax('chad_2/messaggi_non_letti/utente', { FK_ID_UTENTE: this.$root.utente.ID_UTENTE }, (response) => {
				if (response && response.esito == 0) {
					this.arrayMessaggiNonLetti = response.data;
					this.contatoreMessaggi = this.arrayMessaggiNonLetti.messaggi_non_letti.length
				}
			},false);
		},
      
    },

    created: function () {
        this.utente = this.$root.utente;

    },


}
</script>